'use client';

import clsx from 'clsx';
import tableStyles from '../../styles.module.css';

interface TableSkeletonProps {
  columns?: number;
  rows?: number;
  rowHeight?: number;
  className?: string;
}

const DEFAULT_COLUMNS = 6;
const DEFAULT_ROWS = 10;
const CELL_WIDTHS = ['w-[72%]', 'w-[56%]', 'w-[64%]', 'w-[48%]'] as const;

function SkeletonBar({ index }: { index: number }) {
  return (
    <div
      className={clsx('h-4 animate-pulse rounded bg-grey-200', CELL_WIDTHS[index % CELL_WIDTHS.length])}
      aria-hidden
    />
  );
}

export function TableSkeleton({
  columns = DEFAULT_COLUMNS,
  rows = DEFAULT_ROWS,
  rowHeight = 72,
  className,
}: TableSkeletonProps) {
  const columnIndexes = Array.from({ length: columns }, (_, index) => index);
  const rowIndexes = Array.from({ length: rows }, (_, index) => index);

  return (
    <div className={tableStyles.tableContainer}>
      <table className={clsx(tableStyles.table, className)}>
        <thead className={tableStyles.tableHeader}>
          <tr>
            {columnIndexes.map((columnIndex) => (
              <th key={`skeleton-header-${columnIndex}`}>
                <div className={tableStyles.headerCell}>
                  <SkeletonBar index={columnIndex} />
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody className={tableStyles.tableBody}>
          {rowIndexes.map((rowIndex) => (
            <tr key={`skeleton-row-${rowIndex}`} className={tableStyles.tableRow}>
              {columnIndexes.map((columnIndex) => (
                <td key={`skeleton-cell-${rowIndex}-${columnIndex}`}>
                  <div className={tableStyles.tableCell} style={{ height: rowHeight }}>
                    <SkeletonBar index={rowIndex + columnIndex} />
                  </div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
